export default {
  headerDetails: "Produktdetails",
  "headerSign In": "Anmelden",
  headerSettings: "Einstellungen",
  headertransaction: "Bestellungen",
  signin: "Anmelden",
  signinReq: "* Kennzeichnet ein Pflichtfeld",
  emailReq:"E-Mail*",
  passwordReq:"Passwort*",
  newTo: "Neu bei CalmPurr?",
  createAccount: "Konto erstellen",
  firstName: "Vorname*",
  lastName: "Nachname*",
  streetaddress: "Straße und Hausnummer*",
  state: "Bundesland*",
  city: "Stadt*",
  zip: "PLZ*",
  phone: "Telefon*",
  country: "Land*",
  done: "Fertig",
  categoryPopular: "Beliebt",
  categoryCustom: "Foto-Anfertigung",
  categoryFat: "Dicker Kater",
  categorySlim: "Schlanker Kater",
  categoryMini: "Mini-Katze",
  freeShippingTips: "Weltweiter kostenloser Versand auf alle Bestellungen!",
  alreadyHaveAccount: "Schon ein Konto?",
  code: "Code",
  bestseller: "Bestseller",
  recommendforyou: "Empfohlen für dich",
  ourcustomershow: "Kundenfotos",
  faq: "FAQ",
  faq1: "Versendet ihr international?",
  faq1answer: "Ja! Wir versenden in über 90 Länder weltweit. Um zu prüfen, ob wir in deine Region liefern, gib deine Adresse einfach während des Checkouts ein. Wir arbeiten ständig daran, unsere internationalen Versandmöglichkeiten zu erweitern✈️",
  faq2: "Wie lange dauert der Versand?",
  faq2answer: "Je nach Region dauert der Standardversand etwa 6–10 Werktage. Für maßgefertigte Produkte benötigen wir zusätzlich 3–7 Tage Produktionszeit. Sobald dein Paket versendet wurde, erhältst du eine Sendungsverfolgung per E-Mail.💖",
  faq3:"Wie verfolge ich meine Bestellung?",
  faq3answer: "Nach dem Versand findest du die Sendungsnummer sowie alle Tracking-Informationen auf deiner Bestellseite — dort kannst du den aktuellen Status jederzeit einsehen.",
  faq4:"Woraus besteht das Produkt? Ist es sicher?",
  faq4answer: "Unsere CalmPurr-Squishies werden aus lebensmittelechtem Silikon hergestellt — weich, sicher, ungiftig und angenehm anzufassen.",
  faq5:"Wie langlebig ist es? Geht es leicht kaputt?",
  faq5answer: "Unsere Squishies sind sehr strapazierfähig und können viele Male gedrückt werden! Wir empfehlen, sie in der Originalverpackung aufzubewahren, um Form und Qualität länger zu erhalten.",
  review1: "Ich liebe ihn so sehr! Auch die Verpackung war super liebevoll gestaltet. Ich freue mich darauf, ihn an einem besonderen Platz auszustellen!",
  review2: "Super süßer Squishy, tolle Qualität! Er kommt sogar mit einem niedlichen Beutel und Zubehör 😍",
  review3: "Es hat etwas gedauert, aber es hat sich absolut gelohnt. Eine perfekte Nachbildung einer Bengalkatze – wunderschön und so liebevoll bemalt! 😍",
  review4: "Ich habe so viel Fell nicht erwartet, aber es ist mir egal, denn ER IST SOOOO SÜSS! Perfekt als kleiner Stressball für mich!",
  review5: "Super süß, super Qualität. Ich hätte nicht erwartet, dass es so hochwertig ist!",
  review6: "Ich habe meinen Kater im Januar verloren und diesen Squishy nach seinem Bild bestellt… es hat mir wirklich geholfen.",
  review7: "Ich habe es als Geschenk für eine wundervolle Freundin bestellt 💓 – perfekter Zustand, absolut lohnenswert!",
  review8: "Ich liebe meine Katze! Der Versand war schnell und der kleine Korb ist so süß! Ich werde bald noch einen bestellen. Danke, Bambi!",
  aboutus:"Über uns",
  contactus: "Kontakt",
  privacypolicy: "Datenschutzerklärung",
  terms: "AGB",
  returnpolicy: "Rückgaberecht",
  footertitle: "Handgefertigte Silikonkatzen",
  home: "Startseite",
  shoppingcart: "Warenkorb",
  orderhistory: "Bestellverlauf",
  settings: "Einstellungen",
  youshippinginfo: "Deine Versanddaten",
  shipping: "Versand",
  payment: "Zahlung",
  apply: "Anwenden",
  description: "Beschreibung",
  shippingInfo: "Versandinformationen",
  buyText: "Kaufen",
  addtocart: "Zum Warenkorb hinzugefügt!",
  thankyou: "Vielen Dank",
  yoursavings: "Deine Ersparnis",
  shippingInfoDetail: "Kostenloser Versand. Weltweiter Versand möglich.",
  cartisempty: "Dein Warenkorb ist leer",
  continueshopping: "Weiter einkaufen",
  itemtotal: "Zwischensumme",
  freeshipping: "Kostenloser Versand",
  ordertotal: "Gesamt",
  notorderyet: "Du hast noch keine Bestellung aufgegeben.",
  shopnow: "Jetzt einkaufen",
  changeemail: "E-Mail ändern",
  changepass: "Passwort ändern",
  logout: "Abmelden",
  changeemailtips: "Verwende dieses Formular, um deine E-Mail-Adresse zu ändern.",
  currentemail: "Aktuelle E-Mail",
  newemail: "Neue E-Mail",
  confirmemail: "Neue E-Mail bestätigen",
  enteremail: "E-Mail eingeben",
  enterconfirmemail: "E-Mail bestätigen",
  couponoff5title: "5% RABATT",
  couponoff5desc: "Ab €50 Bestellwert",
  couponoff10title: "10% RABATT",
  couponoff10desc: "Ab €60 Bestellwert",
  couponoff15title: "15% RABATT",
  couponoff15desc: "Ab €80 Bestellwert",
  contactemail: "Bitte gib deine E-Mail ein*",
  contactsubject: "Betreff*",
  contactDesc: "Beschreibung*",
  areyousure: "Bist du sicher?",
  cancelshipping: "Möchtest du das Eingeben deiner Versandinformationen abbrechen?",
  enterpromotioncode: "Gutscheincode eingeben",
  removeItemTips: "Diesen Artikel aus dem Warenkorb entfernen?",
  removeItem: "Artikel entfernen",
  cancel: "Abbrechen",
  placeorder: "Bestellung abschicken",
  currencyChangeTips: "Nur zur Orientierung. Die Zahlung erfolgt in Euro (€).",
  selectCurrency: "Währung auswählen",
  approx: "Ca.",
  specialOffer: "Sonderangebot",
  christmasOffer: "Neujahrs-Special 2026",
  christmasOfferCopy: "Klicken Sie auf den untenstehenden Code, um ihn zu kopieren",
  christmasOfferCondition: "Bestellwert über 50 €",
};



// WEBPACK FOOTER //
// ./src/lang/de.js